export default {
  data() {
    return {
      fadeInLeftFrom: {
        opacity: 0,
        transform: 'translate3d(-100%, 0, 0)',
      },
      fadeInLeftTo: {
        opacity: 1,
        transform: 'translate3d(0, 0, 0)',
      },
    };
  },
  methods: {
    handleFadeInInit(el) {
      for (let prop in this.fadeInLeftFrom) {
        el.style[prop] = this.fadeInLeftFrom[prop];
      }
    },
    handleFadeInEnter(el, done) {
      const { delayBase, delayInterval, order } = el.dataset;
      const delay = Number(delayBase) + Number(order) * Number(delayInterval);
      setTimeout(() => {
        this.$Velocity(el, this.fadeInLeftTo, { complete: done });
      }, delay);
    },
    handleFadeInLeave(el, done) {
      this.$Velocity(el, this.fadeInLeftFrom, { complete: done });
    },
  },
};
